import { Link } from 'react-router-dom';

import logo from '../assets/logo.jpeg';

import '../styles.css';

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import { HeaderData } from '../data/HeaderData.jsx';

function Header() {
	return (
		<Navbar
			collapseOnSelect
			expand="lg"
			bg="transparent"
			variant="light"
			className="header"
		>
			<Container>
				<Link className="header_brandname" to="/">
					<Navbar.Brand className="header_brandname_text">
						<img
							src={logo}
							alt=""
							width={50}
							height={50}
							className="header_brandname_img"
						/>
						APL WIN
					</Navbar.Brand>
				</Link>
				<Navbar.Toggle aria-controls="responsive-navbar-nav" />
				<Navbar.Collapse id="responsive-navbar-nav">
					<Nav className="me-auto"></Nav>
					<Nav>
						{HeaderData.map((item) => (
							<Nav.Link>
								<Link
									className="header-navlink"
									to={item.link}
								>
									{item.name}
								</Link>
							</Nav.Link>
						))}
					</Nav>
				</Navbar.Collapse>
			</Container>
		</Navbar>
	);
}

export default Header;
